import { MobileBaseObject } from './mobile-base-object'
import { List } from 'immutable';
import { Remark } from './remark';
import { Actor } from './actor';


export interface ILiveFlight extends MobileBaseObject {
  scheduledDate?: string;
  flightNumber?: string;
  terminal?: string;
  departureDateTime?: Date;
  actualTime?: string;
  arrivalDateTime?: Date;
  scheduledTime?: Date;
  probableTime?: Date;
  boardingTime?: Date;
  blockTime?: Date;
  gate?: string;
  previousGate?: string;
  pier?: string;
  callSign?: string;
  handling?: string;
  addOnRaw?: string;
  stand?: string;
  previousStand?: string;
  aircraftRegistration?: string;
  airportId?: string;
  operatorId?: string;
  operatorName?: string;
  arrivalDestinationName?: string;
  arrivalDestinationIATA?: string;
  departureDestinationName?: string;
  departureDestinationIATA?: string;
  arrivalStatus?: string;
  departureStatus?: string;
  pax?: string;
  flightServiceTypeIata?: string;
  aircraft?: string;
  diIndicator?: string;
  bus?: boolean;
  arrivalBaggage: string;
  departureLocation: string;
  comment: string;
  acknowledge: boolean;
  numberOfBuses: number;
  actors: List<Actor>;
  remarks: List<Remark>;
  isArrival: boolean;
}

export class LiveFlight extends MobileBaseObject implements ILiveFlight {
  public isArrival: boolean;
  public scheduledDate?: string;
  public flightNumber?: string;
  public terminal?: string;
  public departureDateTime?: Date;
  public actualTime?: string;
  public arrivalDateTime?: Date;
  public scheduledTime?: Date;
  public probableTime?: Date;
  public boardingTime?: Date;
  public blockTime?: Date;
  public gate?: string;
  public previousGate?: string;
  public pier?: string;
  public callSign?: string;
  public handling?: string;
  public addOnRaw?: string;
  public stand?: string;
  public previousStand?: string;
  public aircraftRegistration?: string;
  public airportId?: string;
  public operatorId?: string;
  public operatorName?: string;
  public arrivalDestinationName?: string;
  public arrivalDestinationIATA?: string;
  public departureDestinationName?: string;
  public departureDestinationIATA?: string;
  public arrivalStatus?: string;
  public departureStatus?: string;
  public pax?: string;
  public flightServiceTypeIata?: string;
  public aircraft?: string;
  public diIndicator?: string;
  public bus?: boolean;
  public arrivalBaggage: string;
  public departureLocation: string;
  public comment: string;
  public acknowledge: boolean;
  public numberOfBuses: number;
  public actors: List<Actor>;
  public remarks: List<Remark>;

  ////virtual
  //public airport?: Airport;

  public constructor(liveFlight: Partial<ILiveFlight>

  ) {

    super();
    this.isArrival = liveFlight.id.endsWith("_A");

    this.flightNumber = liveFlight.flightNumber;
    this.scheduledDate = liveFlight.scheduledDate;
    this.flightNumber = liveFlight.flightNumber;
    this.terminal = liveFlight.terminal;
    this.departureDateTime = liveFlight.departureDateTime ? new Date(liveFlight.departureDateTime) : liveFlight.departureDateTime;
    this.actualTime = liveFlight.actualTime;
    this.arrivalDateTime = liveFlight.arrivalDateTime ? new Date(liveFlight.arrivalDateTime) : liveFlight.arrivalDateTime;
    this.scheduledTime = liveFlight.scheduledTime ? new Date(liveFlight.scheduledTime) : liveFlight.scheduledTime;
    this.probableTime = liveFlight.probableTime ? new Date(liveFlight.probableTime) : liveFlight.probableTime;
    this.boardingTime = liveFlight.boardingTime ? new Date(liveFlight.boardingTime) : liveFlight.boardingTime;
    this.blockTime = liveFlight.blockTime ? new Date(liveFlight.blockTime) : liveFlight.blockTime;
    this.gate = liveFlight.gate;
    this.previousGate = liveFlight.previousGate;
    this.pier = liveFlight.pier;
    this.callSign = liveFlight.callSign;
    this.handling = liveFlight.handling;
    this.addOnRaw = liveFlight.addOnRaw;
    this.stand = liveFlight.stand;
    this.previousStand = liveFlight.previousStand;
    this.aircraftRegistration = liveFlight.aircraftRegistration;
    this.airportId = liveFlight.airportId;
    this.operatorId = liveFlight.operatorId;
    this.operatorName = liveFlight.operatorName;
    this.arrivalDestinationName = liveFlight.arrivalDestinationName
    this.arrivalDestinationIATA = liveFlight.arrivalDestinationIATA;
    this.departureDestinationName = liveFlight.departureDestinationName;
    this.departureDestinationIATA = liveFlight.departureDestinationIATA;
    this.arrivalStatus = liveFlight.arrivalStatus;
    this.departureStatus = liveFlight.departureStatus;
    this.pax = liveFlight.pax;
    this.flightServiceTypeIata = liveFlight.flightServiceTypeIata;
    this.aircraft = liveFlight.aircraft;
    this.diIndicator = liveFlight.diIndicator;
    this.bus = liveFlight.bus;
    this.arrivalBaggage = liveFlight.arrivalBaggage;
    this.departureLocation = liveFlight.departureLocation;
    this.comment = liveFlight.comment;
    this.acknowledge = liveFlight.acknowledge;
    this.numberOfBuses = liveFlight.numberOfBuses ? liveFlight.numberOfBuses : 1;
    let actors: List<Actor> = List<Actor>();
    this.remarks = liveFlight.remarks;
    if (liveFlight.actors) {
      //Only if expanded
      liveFlight.actors.forEach(function (actor) { actors = actors.push(new Actor(actor)); });
    }

    this.actors = actors;
    this.id = liveFlight.id;
    this.createdAt = liveFlight.createdAt;
    this.updatedAt = liveFlight.updatedAt;

  }
  public get isRemoteGate() {
    return this.gate?.toUpperCase().startsWith("A");
  }
  public get aircraftExpanded(): DepartureAircraft {
    return JSON.parse(this.aircraft) as DepartureAircraft;
  }
  public set aircraftExpanded(value: DepartureAircraft) {
    this.aircraft = JSON.stringify(value);
  }

  public get departureStatusExpanded(): DepartureStatus {
    return JSON.parse(this.departureStatus) as DepartureStatus;
  }
  public set departureStatusExpanded(value: DepartureStatus) {
    this.departureStatus = JSON.stringify(value);
  }

  public get arrivalStatusExpanded(): ArrivalStatus {
    return JSON.parse(this.arrivalStatus) as ArrivalStatus;
  }
  public set arrivalStatusExpanded(value: ArrivalStatus) {
    this.arrivalStatus = JSON.stringify(value);
  }

}

export class DepartureAircraft {
  public iataType: string;
  public icaoType: string;
  public seatingCapacity: number;
}

export class ArrivalStatus {
  public constructor(
    public flightStatusSwedish: List<string>,
    public flightStatusEnglish: List<string>,
    public flightLegStatus: FlightLegStatus
  ) { }
}

export class DepartureStatus {
  public constructor(
    public gateAction: GateAction,
    public checkInClose: Date,
    public gateClose: Date,
    public flightStatusEnglish: List<string>,
    public gateActionEnglish: string,
    public flightLegStatus: FlightLegStatus,
    public checkInStatusEnglish: string,
    public gateOpen: Date,
    public checkInOpen: Date,
    public flightIsCancelled: boolean,
    public flightStatusSwedish: List<string>,
    public gateActionSwedish: string,
    public checkInStatusSwedish: string,
    public checkInStatus: CheckInStatus
  ) { }
}

export class DepartureLocation {
  public constructor(
    public checkInDeskFrom: number,
    public checkInDeskTo: number,
    public terminal: string,
    public gate: string,
    public aircraftParkingPosition: string,
    public stand: string,
    public previousStand: string
  ) { }

}

export class ArrivalBaggage {
  constructor(
    public baggageClaimUnit: string,
    public beltTargetFirstBag: Date,
    public beltFirstBag: Date,
    public beltLastBag: Date
  ) { }

}

export enum FlightLegStatus {
  Act,
  Can,
  Del,
  Div,
  Fls,
  Fpl,
  Lan,
  Rer,
  Sch,
  Seq
}

export enum CheckInStatus {
  C,
  O
}
export enum GateAction {
  B,
  C,
  E,
  F,
  I
}
